import {
  Center, Container,
  Grid, GridItem,
  Spinner
} from "@chakra-ui/react";
import React from "react";
import { useQuery } from "react-query";
import {useNavigate, useParams} from "react-router-dom";

import {getUserResults} from "../Api";
import {Paths} from "../model/Constants";
import {teacherKeys} from "../QueryKeys";
import {displayTime, extractData, getLicenseId, getLicenseName} from "../Utils";

const LicenseResult = () => {
  const navigate = useNavigate();
  const params = useParams<{
    userId: string;
  }>();

  const username = params.userId || "";

  const candidateQuery = useQuery(teacherKeys.userResults(username), () =>
    getUserResults(params.userId, true).then(extractData)
  );

  if (
    (candidateQuery.isFetched && (candidateQuery.data === null || candidateQuery.data === undefined)))
    navigate(Paths.HOME, { replace: true });


  const sizeProps = {
    w:'100%',
    paddingX:'10px',
    paddingY:'4px'
  };
  const blackBg = {
    bg:'blackAlpha.200'
  };
  const grayBg = {
    bg:'gray.200'
  };

  if (!candidateQuery || !candidateQuery.data) {
    return (
      <Center height="200px">
        <Spinner />
      </Center>
    );
  } else {
    return (
      <Container maxW="container.md" marginX="auto">
        <Grid templateColumns='repeat(2, 1fr)' columnGap={1} rowGap={1}>
          <GridItem {...sizeProps} {...blackBg}>Licencia: </GridItem>
          <GridItem {...sizeProps} {...blackBg}>{candidateQuery.data.username}</GridItem>
          <GridItem {...sizeProps} {...blackBg}>Nombre: </GridItem>
          <GridItem {...sizeProps} {...blackBg}>{getLicenseName(candidateQuery.data)}</GridItem>

          <GridItem {...sizeProps} {...grayBg}>Institución: </GridItem>
          <GridItem {...sizeProps} {...grayBg}>{candidateQuery.data.institution}</GridItem>
          <GridItem {...sizeProps} {...blackBg}>Región: </GridItem>
          <GridItem {...sizeProps} {...blackBg}>{candidateQuery.data.region}</GridItem>
          <GridItem {...sizeProps} {...blackBg}>Grupo: </GridItem>
          <GridItem {...sizeProps} {...blackBg}>{candidateQuery.data.userGroup}</GridItem>

          <GridItem {...sizeProps} {...grayBg}>Prueba de lectura: </GridItem>
          <GridItem {...sizeProps} {...grayBg}>{candidateQuery.data.candidateR.level}</GridItem>
          <GridItem {...sizeProps} {...blackBg}>Tiempo (inicio - fin): </GridItem>
          <GridItem {...sizeProps} {...blackBg}>{displayTime(candidateQuery.data.candidateR.startTime)} -
            {displayTime(candidateQuery.data.candidateR.endTime)}</GridItem>

          <GridItem {...sizeProps} {...grayBg}>Prueba de escucha: </GridItem>
          <GridItem {...sizeProps} {...grayBg}>{candidateQuery.data.candidateL.level}</GridItem>
          <GridItem {...sizeProps} {...blackBg}>Tiempo (inicio - fin): </GridItem>
          <GridItem {...sizeProps} {...blackBg}>{displayTime(candidateQuery.data.candidateL.startTime)} -
            {displayTime(candidateQuery.data.candidateL.endTime)}</GridItem>

          <GridItem {...sizeProps} {...grayBg}>Prueba oral: </GridItem>
          <GridItem {...sizeProps} {...grayBg}>{candidateQuery.data.candidateS.level}</GridItem>
          <GridItem {...sizeProps} {...blackBg}>Tiempo (inicio - fin): </GridItem>
          <GridItem {...sizeProps} {...blackBg}>{displayTime(candidateQuery.data.candidateS.startTime)} -
            {displayTime(candidateQuery.data.candidateS.endTime)}</GridItem>

        </Grid>
      </Container>
    );
  }
};

export default LicenseResult;
